<template>
  <div class="register">
    <Form class="form" autocomplete="off">
      <div class="title">欢迎注册艺棒小匠</div>
      <div class="login-tip">
        <span>已有账号？</span>
        <span class="login-btn" @click="$router.push({name:'login'})">登录</span>
      </div>
      <FormItem class="input-view" style="margin-top: 50px">
        <Input number  :maxlength="11"  placeholder="请输入您的手机号" name="register-phone" autocomplete="off" v-model="loginForm.phone">
          <span slot="prefix">
              <img src="../../assets/images/mobile.png" alt class="icon">
          </span>
        </Input>
      </FormItem>
      <FormItem class="input-view">
        <Input placeholder="请设置密码" :maxlength="16" type="password" name="register-password" autocomplete="new-password" v-model="loginForm.password">
           <span slot="prefix">
              <img src="../../assets/images/lock.png" alt class="icon">
          </span>
        </Input>
      </FormItem>

      <FormItem class="input-view">
        <Input placeholder="请输入验证码" number  :maxlength="6"  style="width: 230px" name="register-code" autocomplete="one-time-code" v-model="loginForm.code"></Input>
        <Button type="primary" style="width:150px;height: 40px;margin-left: 18px" @click="getCode()" :disabled="!show">
          <span v-if="show">获取验证码</span>
          <span v-if="!show">{{count}} s</span>
        </Button>
      </FormItem>
      <Button type="primary" style="width: 100%;height: 48px;border-radius: 24px;margin-top: 40px" @click="register()">确定</Button>
    </Form>
  </div>
</template>

<script>
import { isMobile } from '@/libs/validator'
export default {
  name: 'register',
  data () {
    return {
      show: true,
      count: 60,
      timer: null,
      loginForm: {
        phone: '',
        password: '',
        code: ''
      }
    }
  },
  methods: {
    getCode () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (!this.timer) {
        this.$request('610796cfa73ad', {
          phone: this.loginForm.phone + '',
          type: 'register'
        }).then(res => {
          this.show = false
          this.count = 60
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= 60) {
              this.count--
            } else {
              this.show = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        })
      } else {
        return this.$message.error('请求验证码频繁')
      }
    },
    register () {
      if (this.loginForm.phone == '') {
        return this.$message.error('请输入手机号')
      }
      if (!isMobile(this.loginForm.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (this.loginForm.code == '') {
        return this.$message.error('请输入验证码')
      }
      if (this.loginForm.password == '') {
        return this.$message.error('请输入密码')
      }
      this.$request('61873ae74f84d', {
        phone: this.loginForm.phone + '',
        code: this.loginForm.code + '',
        password: this.loginForm.password
      }).then(res => {
        this.$router.push('/Login')
      })
    }
  }
}
</script>

<style scoped lang="less">
.register {
  position: absolute;
  width: 100%;
  height: 100%;
  flex: 1;
  background-image: url("../../assets/images/loginbg.png");
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-tip{
    .login-btn{
      color: #FB9E2F;
      cursor: pointer;
    }
  }

  .form {
    width: 480px;
    background-color: #FFFFFF;
    border-radius: 28px;
    padding: 60px 40px;

    .title {
      font-weight: 600;
      font-size: 30px;
      line-height: 50px;
    }

    .login-type {
      width: 100%;
      border-bottom: 1px solid #F7F7F7;
      display: flex;
      margin-top: 20px;

      .login-btn {
        height: 50px;
        line-height: 50px;
        margin-right: 30px;
        font-weight: 400;
        font-size: 18px;
        cursor: pointer;
      }

      .active {
        color: #FB9E2F;
        font-weight: 600;
        position: relative;

        &:after {
          content: '';
          width: 70px;
          height: 2px;
          background-color: #FB9E2F;
          position: absolute;
          bottom: -0.5px;
          left: 0;
        }
      }
    }

    .input-view {
      margin-top: 30px;

      .icon{
        width: 24px;
        margin-top: 7px;
      }
    }
  }
}
</style>
